export default "__VITE_ASSET__PoUe$VxQ__"